import { useEffect, useRef } from "react";
import { AppTheme } from "./theme";
import { AppRouter } from "./router/AppRouter";
import { AuthProvider } from "./context/AuthContext";
import { DashboardProvider } from "./context/DashboardContext";
import { SidebarProvider } from "./context/SidebarContext";
import { ReactFlowProvider } from "react-flow-renderer";
import {
  useSync,
  useOnlineStatus,
  useSyncPendingChanges,
} from "./hooks/useSync";
import { syncService } from "./helpers/syncService";
import { AuthContext } from "./context/AuthContext";
import { useContext } from "react";

function SyncController() {
  const { user } = useContext(AuthContext);

  const { initialSync } = useSync();
  const isOnline = useOnlineStatus();
  const { syncPendingChanges, pendingCount } = useSyncPendingChanges();

  const pendingCountRef = useRef(pendingCount);
  const hasSyncedOnMount = useRef(false); // para el primer arranque

  useEffect(() => {
    pendingCountRef.current = pendingCount;
  }, [pendingCount]);

  useEffect(() => {
    if (!isOnline) {
      hasSyncedOnMount.current = false;
      return;
    }
    if (!user || user.idPerfil !== 1004) return;

    const sincronizar = async () => {
      const { db } = await import("./libraries/db");
      const pendientes = await db.table("PendingSync").count();

      if (pendientes > 0) {
        await syncPendingChanges();
      } else {
        await syncService.limpiarBaseDatosLocal();
        await initialSync();
      }
    };

    if (!hasSyncedOnMount.current && !syncService.isSyncing()) {
      hasSyncedOnMount.current = true;
      sincronizar();
    }

    const interval = setInterval(sincronizar, 15 * 60 * 1000);
    return () => clearInterval(interval);
  }, [isOnline, user]); // <-- solo isOnline, no pendingCount

  return null;
}

export default function App() {
  return (
    <AppTheme>
      <AuthProvider>
        <SidebarProvider>
          <DashboardProvider>
            <ReactFlowProvider>
              <SyncController />
              <AppRouter />
            </ReactFlowProvider>
          </DashboardProvider>
        </SidebarProvider>
      </AuthProvider>
    </AppTheme>
  );
}
